import React from "react";
import styled from "styled-components";
import Webcam from "react-webcam";
import { faceDetected, livenessDetected } from "assets";

// Styled components for Camera
const CameraContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CameraPreview = styled(Webcam)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1); // Mirror the webcam view
`;

const OvalBorder = styled.div<{ borderColor?: string }>`
  top: auto;
  position: absolute;
  border: 8px solid ${(props) => props.borderColor || "#05A8AA"};
  border-radius: 50%;
  border-radius: 50%;
  width: 300px;
  height: 400px;
  pointer-events: none;
`;

const DetectionStatus = styled.div`
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  gap: 10px;
  margin-top: 28px;
  position: absolute;
  top: 544px;
  left: 10px;
`;


const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.83);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  text-align: center;
  z-index: 0; /* Ensure it overlays the rest */
`;

interface CameraProps {
  isFaceDetected: boolean;
  isLivenessDetected: boolean;
  isAcknowledged?: boolean;
  borderColor?: string;
}

const Camera: React.FC<CameraProps> = ({
  isFaceDetected,
  isLivenessDetected,
  isAcknowledged,
  borderColor,
}) => (
  <CameraContainer>
    <CameraPreview />
    {isAcknowledged && <OvalBorder />}
    {!isAcknowledged && <Overlay />}
    {/* Oval green border overlay */}
    {/* <DetectionStatus>
      {isFaceDetected && (
        <StatusBadge type="success">
          <StatusIcon src={faceDetected} /> Face Detected
        </StatusBadge>
      )}
      {isLivenessDetected && (
        <StatusBadge type="success">
          <StatusIcon src={livenessDetected} /> Liveness Detected
        </StatusBadge>
      )}
    </DetectionStatus> */}
  </CameraContainer>
);

export default Camera;
